import React from 'react'
import { WidgetGuard } from 'features/types'
import { TopicNotSelectedGuard } from '../../../share/guards'
import PerCapitaNotSupportGuard from './PerCapitaNotSupportGuard'

const GeoRegionsWidgetSettingGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <PerCapitaNotSupportGuard widgetId={widgetId}>{children}</PerCapitaNotSupportGuard>
  </TopicNotSelectedGuard>
)

export default GeoRegionsWidgetSettingGuards
